import ConsoleLogger from './ConsoleLogger'
import SentryLogger from './SentryLogger'

/**
 * creates and returns proper instance of logger depends on condition
 *
 * @param {object} sentry
 * @param {function} getContext
 * @param {boolean} isProduction
 * @returns {ILogger}
 */
export default function createLogger (sentry, getContext, isProduction) {
  return isProduction
    ? new SentryLogger(sentry, getContext)
    : new ConsoleLogger(console, getContext)
}



// WEBPACK FOOTER //
// ./src/utils/Logger/index.js